import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import { fetchCurrentUser } from "./redux/activitiesSaga";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { ContactLogsTable } from "./smartComponents/ContactLogsTable";
import CustomDateRanges from "./smartComponents/customDateRanges";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import { UpdateBtns } from "./smartComponents/UpdateBtns";
import { LineChart } from "./smartComponents/LineChart";
import { Dropdown } from "./smartComponents/dropdown";
import DatePicker from "./smartComponents/datePicker";

const Activities = (props) => {
  const isLoading = useSelector((state) => state.activities.isLoading);
  const initialRequest = useSelector((state) => state.activities.initialRequest);
  const isAllSitesMode = useSelector((state) => state.activities.isAllSitesMode);
  const areChartsLoading = useSelector((state) => state.activities.areChartsLoading);
  const {
    tableData: { isLoading: isTableLoading },
    lineChartData: { isLoading: isLineChartLoading }
  } = useSelector((state) => state.activities.chartsData);

  const dispatch = useDispatch();

  useEffect(() => {
    if (!initialRequest) {
      dispatch(fetchCurrentUser(props));
    }
  }, []);

  const content = () => {
    return (
      <>
        {isAllSitesMode ? (
          <p className="error error--big" style={{ ...errorMessageStyles }}>
            Not Available in All Sites View, when user has access to more than 100 locations
          </p>
        ) : (
          <div id="module-date-filters" data-testid="activities">
            <div id="override-edit-selection-bar" className="edit-selections-bar">
              <div className="top-filter">
                <div style={{ flexBasis: "25%" }}>
                  <div className="select-box-no-width" data-testid="Staffs">
                    <p data-testid="filterTitle">Staff</p>
                    <Dropdown placeholder="Staffs" sliceKey="staffs" />
                  </div>
                </div>

                <div className="top-filter__right">
                  <div
                    className="select-box-no-width date-range-select-box"
                    data-testid="Date Range"
                  >
                    <p data-testid="filterTitle">Date Range</p>
                    <CustomDateRanges />
                  </div>

                  <div className="date-select-box multi" data-testid="Date">
                    <p data-testid="filterTitle">Date</p>
                    <DatePicker />
                  </div>
                </div>
              </div>

              <UpdateBtns params={props} />
            </div>

            <div>
              {areChartsLoading ? (
                <LoadingAnimation text="Loading.." />
              ) : (
                <>
                  {isLineChartLoading ? (
                    <LoadingAnimation text="Updating data..." />
                  ) : (
                    <LineChart />
                  )}
                  {isTableLoading ? (
                    <LoadingAnimation text="Updating data..." />
                  ) : (
                    <ContactLogsTable />
                  )}
                </>
              )}
            </div>
          </div>
        )}
      </>
    );
  };
  return (
    <SectionToggle
      isLoading={isLoading}
      title="Activities"
      content={content()}
      learnMore={
        <KBLearnMore
          title="Activities"
          description="This report shows staff interactions with clients, including logged communications and recorded in-person outreach. These insights help you understand team engagement levels and evaluate how staff activity supports retention and customer satisfaction."
          kbUrl={ILEARN_URLS.staffActivity.activities}
        />
      }
    />
  );
};

const errorMessageStyles = {
  textAlign: "center",
  fontSize: "48px",
  wordSpacing: 0,
  lineHeight: "60px"
};

export default Activities;
